import React, {Component, Fragment,} from 'react'
import {Form, Table,} from 'antd'
import {reqGetVehicle, reqGetDrivers, baseUrl, reqImportOrderVehicles,} from '../../api'

class ImportOrderTrain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vehicle: {},
            drivers: [],
        };
        this.columns = [
            {
                title: '姓名',
                dataIndex: 'name',
            }, {
                title: '手机',
                dataIndex: 'phone',
            }, {
                title: '身份证',
                dataIndex: 'identification',
            }
        ];
    }


    render() {
        const {order} = this.props;
        return (
            <div className="vehicle-driver">
                <div className="vehicle-driver-head flex-between">
                    <div className="tab">班列</div>
                    <div className="other"></div>
                </div>
                <div className="vehicle-driver-content">
                    <div className="title flex-between">
                        <div>班列</div>
                    </div>
                    <Fragment>
                        <div>班列号 : {order.trainNo}</div>
                        <br/>
                        <div>发运时间: {order.trainStartDt}</div>
                    </Fragment>
                </div>
            </div>
        )
    }
}

const ImportOrderTrainFrom = Form.create()(ImportOrderTrain);
export default ImportOrderTrainFrom